export const getCurrentUnixTime = () => {
  return Math.floor(Date.now() / 1000);
};
